export default __webpack_public_path__ + "static/media/1.e19d3bb7.jpg";